export const LOCALIZED_DATA = [
    { lang: 'ru', label: 'На русском' },
    { lang: 'kk', label: 'На казахском' },
    { lang: 'en', label: 'На английском' },
    { lang: 'qq', label: 'На казахском (латиница)' },
];